import { createPortal } from "react-dom";
import { useMap } from "react-leaflet";
import { useDispatch } from "react-redux";
import { setModal } from "../../store/reducers/helpersReducer";
import { Dialog } from "@mui/material";
import ConclusionsView from "../contents/ConclusionsView";

const ModalConclusions = (props) => {
    const map = useMap();
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setModal(null));
    };

    return (
        // createPortal(
        <Dialog
            open={true}
            fullScreen={true}
            maxWidth="lg"
        >
            <ConclusionsView
                isModal={true}
                onClose={handleClose}
                map={map}
                fromStartPage={false}
            />
        </Dialog>
        // ,
        //     document.body
        // )
    );
};

export default ModalConclusions;
